module.exports = __webpack_public_path__ + "img/salad.21c621b3.svg";